import { css, cva } from '@/styled-system/css';
import { shimmerStyles } from '@zg-rentals/loading-components';

export const overlayRecipe = cva({
  base: {
    position: 'absolute',
    inset: '0',
    zIndex: '1',
  },
  variants: {
    isDisabled: {
      true: { cursor: 'not-allowed' },
      false: { cursor: 'pointer' },
    },
    hasError: {
      true: { backgroundColor: 'rgba(255, 255, 255, 0.5)' },
    },
  },
});

export const iconContainerStyles = css.raw({
  position: 'absolute',
  bottom: '200',
  right: '200',
  zIndex: '2',
});

export const backgroundLoadingImageStyles = css.raw({
  height: { base: '90px', lg: '100px' },
  position: 'absolute',
  width: '100%',
  ...shimmerStyles,
});

export const backgroundImageContainerStyles = css.raw({
  borderRadius: '100',
  height: { base: '90px', lg: '100px' },
  overflow: 'hidden',
  position: 'relative',
  touchAction: 'none',
});
